export default __webpack_public_path__ + "microphone-black-shape.png";